import React from 'react';

const GoogleMapComponent = () => {
    return (
        <div style={{ position: 'relative', width: '100%', height: '500px' }}>
            {/* Aquí insertamos el iframe con la nueva URL proporcionada */}
            <iframe
                title="Google Map"
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2457.382766874812!2d-77.0304958447477!3d-12.12226315453683!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x9105c8196b58a541%3A0xfddee93ece6d01e3!2sDentisan+Clinica+Dental!5e0!3m2!1ses!2ses!4v1502605107485"
                width="100%"  // Hace que ocupe todo el ancho disponible
                height="100%" // Hace que ocupe todo el alto disponible
                frameBorder="0"
                style={{ border: 0 }}
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
            ></iframe>
        </div>
    );
};

export default GoogleMapComponent;
